module.exports = __webpack_public_path__ + "img/collect-black.681e4ca8.svg";